import { ReactNode } from 'react'
import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'

import AutoCompleteField from 'src/components/shared/ui/form/fields/AutoCompleteField'
// import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import NumeroCompuestoField from 'src/components/views/EscritosLexnet/components/shared/components/fields/NumeroCompuesto/NumeroCompuestoField'
import { OrganoDestinoFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/organoDestinoTypes'
import { ProcedimientoFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/procedimientoTypes'
import { FormField } from 'src/enums/Form'
import {
  useGetProcedimientoTipologia,
  useGetProcedimientoTipo
} from 'src/hooks/fetch/useCatalogoGeneralFilters'
import { Orden, OrganoJudicial } from 'src/interfaces/Catalog'
import RequiredText from '../../RequiredText'

type Props = {
  values: ProcedimientoFormValues
  labels: { tipo: string; numero: string }
  showPiezaSection: () => void
  organoJudicial: OrganoJudicial
  orden: Orden
  checkIfDisabledField: () => boolean
}

function ProcedimientoFormView({
  values,
  labels,
  showPiezaSection,
  organoJudicial,
  orden,
  checkIfDisabledField
}: Props): JSX.Element {
  const { setFieldValue } = useFormikContext<OrganoDestinoFormValues>()

  const tipologias = useGetProcedimientoTipologia(FormField.PROCEDIMIENTO_TIPOLOGIA_FORM)

  function handleFieldChange(_field: string) {
    setFieldValue(FormField.PROCEDIMIENTO_TIPO_FORM, null)
  }

  function getProcedimientoLabel(option) {
    return option && option.texto
      ? `${option.texto} [${option.codigo}] (${orden.descripcion})`
      : option
  }

  function renderProcedimientoOption(props, option) {
    return (
      <li
        {...props}
        key={props.key}
      >{`${option.texto} [${option.codigo}] (${orden.descripcion})`}</li>
    )
  }

  function AutoCompleteProcedimientoTipo(): ReactNode {
    const proc = useGetProcedimientoTipo(
      FormField.PROCEDIMIENTO_TIPO_FORM,
      [values[FormField.PROCEDIMIENTO_TIPOLOGIA_FORM], organoJudicial, orden],
      organoJudicial?.adaptadoTest
    )
    const tipologiasParsed: any = []

    tipologias?.forEach((t: any) => {
      if (proc?.some(p => t.codigo === p.tipologia)) {
        tipologiasParsed.push(t)
      }
    })

    return (
      <>
        <Grid item xs={6}>
          <AutoCompleteField
            id={FormField.PROCEDIMIENTO_TIPOLOGIA_FORM}
            items={tipologiasParsed}
            onChange={handleFieldChange}
            label={t('form.field.procedimiento_tipologia')}
            itemName="descripcion"
            disabled={checkIfDisabledField()}
          />
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteField
            id={FormField.PROCEDIMIENTO_TIPO_FORM}
            items={proc}
            label={t(labels.tipo)}
            itemName="texto"
            getOptionLabelCallback={getProcedimientoLabel}
            renderOptionCallback={renderProcedimientoOption}
            sortBy
            required
            disabled={checkIfDisabledField()}
          />
        </Grid>
      </>
    )
  }

  return (
    <>
      <RequiredText />
      <Grid container spacing={2}>
        {AutoCompleteProcedimientoTipo()}
        <Grid item xs={6}>
          <NumeroCompuestoField
            label={t(labels.numero)}
            ids={{
              number: FormField.PROCEDIMIENTO_NUMERO_FORM,
              year: FormField.PROCEDIMIENTO_YEAR_FORM
            }}
            disabled={checkIfDisabledField()}
          />
        </Grid>
        {showPiezaSection()}
      </Grid>
    </>
  )
}

export default ProcedimientoFormView
